import { useQuery } from "@tanstack/react-query";
import { useDynamicSupabase } from "@/hooks/useDynamicSupabase";

export interface PackageFinancialMetric {
  packageId: string;
  packageTitle: string;
  baseCost: number;
  sellingPrice: number;
  profitMargin: number;
  actualProfit: number;
  marketingCost: number;
  operationalCost: number;
  netProfit: number;
  roi: number;
}

export const usePackageFinancialMetrics = (packageId?: string, period: string = 'monthly') => {
  const { supabase } = useDynamicSupabase();
  
  return useQuery({
    queryKey: ["package-financial-metrics", packageId, period],
    queryFn: async (): Promise<PackageFinancialMetric[]> => {
      // Get financial metrics
      let query = supabase
        .from("package_financial_metrics")
        .select(`
          *,
          package:tourism_packages(id, title, price)
        `) as any;

      if (packageId) {
        query = query.eq('package_id', packageId);
      }

      const { data, error } = await query;

      if (error) throw error;

      return data?.map((metric: any) => ({
        packageId: metric.package_id,
        packageTitle: (metric.package as any)?.title || 'Unknown',
        baseCost: metric.base_cost || 0,
        sellingPrice: metric.selling_price || 0,
        profitMargin: metric.profit_margin || 0,
        actualProfit: metric.actual_profit || 0,
        marketingCost: metric.marketing_cost || 0,
        operationalCost: metric.operational_cost || 0,
        netProfit: metric.net_profit || 0,
        roi: metric.roi || 0
      })) || [];
    }
  });
};
